/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {
  TableDefault,
  ShadowTableHead,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
  ArrowDownContainer,
  ShadowTableColumn,
  DownloadButton,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp, GoArrowDown} from 'react-icons/go';
import {capitalizeFirstLetters} from '../../utils/hooks/text-formatter';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';
import {Admin} from '../../utils/api';

export default ({
  player,
  dataTableContent,
  dataAverage,
  dataCy,
  fatigueZone,
  setTableUpdated,
  hideExam,
}: {
  player: any;
  dataTableContent: Array<any>;
  dataAverage: any;
  dataCy?: string;
  fatigueZone?: boolean;
  setTableUpdated?: any;
  hideExam?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const [loading, useLoading] = useState<boolean>(false);
  const UTILS = new Utils();
  const ADMIN = new Admin();

  useEffect(() => {
    useTable(dataTableContent);
    useLoading(false);
  }, [dataTableContent]);

  useEffect(() => {
    if (loading) {
      setTableUpdated(true);
    }
  }, [loading]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function changeStatus(change) {
    // if (change < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickySubHeader onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickySubHeader>
    );
  }
  function SortingShadowTableHead({title = '', attr, location, sortFunction}) {
    return (
      <ShadowTableHead onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </ShadowTableHead>
    );
  }

  async function DownloadReport(examId, name, date) {
    const names = name.split(' ');
    const firstname = names?.[0] ?? '';
    const lastname = name.length > 2 ? `${names?.[1] ?? ''}${names?.[2] ?? ''}` : (names?.[1] ?? '');
    ADMIN.GetPlayerExamById(examId, firstname, 'Post_' + lastname, date);
  }

  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyMainHeader colSpan={1}>HIDE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>DATE</StickyMainHeader>
          <StickyMainHeader colSpan={3}>EVENT</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL STRENGTH</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>SCAPTION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>GRIP</StickyShadowMainHeader>
          <StickyMainHeader colSpan={1}>REPORT</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <SortingTableHead title="Sort date" attr="date" location={['date']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Type" attr="type" location={['event', 'type']} sortFunction={toggleSortString} />
          <SortingTableHead title="Pitches" attr="pitches" location={['event', 'pitches']} sortFunction={toggleSortString} />
          <SortingTableHead title="RPE" attr="rpe" location={['event', 'rpe']} sortFunction={toggleSortString} />
          <SortingShadowTableHead
            title="% Fresh"
            attr="tcurrent"
            location={['strength', 'freshTotalRatio']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead
            title="Change (lbs)"
            attr="tchange"
            location={['strength', 'freshTotalChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="% Fresh" attr="ircurrent" location={['strength', 'freshERRatio']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Change (lbs)"
            attr="irchange"
            location={['strength', 'freshERChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead title="% Fresh" attr="ercurrent" location={['strength', 'erCurrent']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead
            title="Change (lbs)"
            attr="erchange"
            location={['strength', 'erChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="% Fresh" attr="scurrent" location={['strength', 'scaptionCurrent']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Change (lbs)"
            attr="schange"
            location={['strength', 'scaptionChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead
            title="% Fresh"
            attr="gripCurrent"
            location={['strength', 'gripCurrent']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead
            title="Change (lbs)"
            attr="gripChange"
            location={['strength', 'gripChange']}
            sortFunction={toggleSortNumber}
          />
          <StickySubHeader />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>Avg</td>
            <td>{loading && <Loader width="20px" color="#B1D6FF" />}</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.freshTotalRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(dataAverage?.freshTotalChange)}
              {changeStatus(dataAverage?.freshTotalChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.freshIRRatio, {digits: 0})}</td>
            <td>
              {numberColumnFormatter(dataAverage?.freshIRChange)}
              {changeStatus(dataAverage?.freshIRChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.freshERRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(dataAverage?.freshERChange)}
              {changeStatus(dataAverage?.freshERChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.freshScaptionRatio, {digits: 0})}</td>
            <td>
              {numberColumnFormatter(dataAverage?.freshScaptionChange)}
              {changeStatus(dataAverage?.freshScaptionChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.freshGripRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(dataAverage?.freshGripChange)}
              {changeStatus(dataAverage?.freshGripChange)}
            </ShadowSummaryColumn>
            <td></td>
          </TeamAverageRow>
        )}
        {table.length > 0 ? (
          table.map((item, index) => {
            return (
              <TableItem
                key={item.postExamId}
                item={item}
                useLoading={useLoading}
                fatigueZone={fatigueZone}
                changeStatus={changeStatus}
                DownloadReport={DownloadReport}
                hideExam={hideExam}
                player={player}
              />
            );
          })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, DownloadReport, hideExam, player}) => {
  const [hide, setHide] = useState<Boolean>(item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.excludeFromExamAvg ? '0.5' : '1');

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    hide ? setOpacity('0.5') : setOpacity('1');
    hideExam(item.postExamId, hide, 'post');
    useLoading(true);
  }, [hide]);

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }

  return (
    <tr style={{opacity: opacity}}>
      <td className="white pointer" onClick={() => setHide(!hide)}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOn" />}
      </td>
      <td className="white">{handleDate(item?.date)}</td>
      <td className="white">{capitalizeFirstLetters(item?.event?.type, '_')}</td>
      <td className="white">
        {item?.event?.type === 'velo_day' ? item?.event?.highIntentsThrows : numberColumnFormatter(item?.event?.pitches, {digits: 0})}
      </td>
      <td className="white">{item?.event?.rpe || '-'}</td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshTotalRatio, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.armFatigueTotal)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshTotalChange)}
        {changeStatus(item?.strength?.freshTotalChange)}
      </ShadowTableColumn>
      <td className="white">
        {numberColumnFormatter(item?.strength?.freshIRRatio, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.armFatigueIR)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.strength?.freshIRChange)}
        {changeStatus(item?.strength?.freshIRChange)}
      </td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshERRatio, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.armFatigueER)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshERChange)}
        {changeStatus(item?.strength?.freshERChange)}
      </ShadowTableColumn>
      <td className="white">
        {numberColumnFormatter(item?.strength?.freshScaptionRatio, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.armFatigueScaption)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.strength?.freshScaptionChange)}
        {changeStatus(item?.strength?.freshScaptionChange)}
      </td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshGripRatio, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.armFatigueGrip)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.freshGripChange)}
        {changeStatus(item?.strength?.freshGripChange)}
      </ShadowTableColumn>
      <td className="white">
        {item?.enabledPDF && (
          <DownloadButton type="PDF" onClick={() => !hide && DownloadReport(item?.postExamId, player?.name, item?.date)}>
            ↓ PDF
          </DownloadButton>
        )}
      </td>
    </tr>
  );
};
